export default __webpack_public_path__ + "static/media/engagement_rate.5cbf6621.svg";